module.exports = __webpack_public_path__ + "static/media/wireframe2.3aca32f8.webp";